<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24" class="search-area">
        <el-col :span="6">
          <div class="search-area-div">
            <span class="fontC-red">*</span>
            留存公司
          </div>
          <el-select
            @change="onChangeTenant"
            v-model="page.tenantGuid"
            placeholder="请选留存公司"
            class="ipt-sty"
            filterable
            size="mini"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">
            <span class="fontC-red">*</span>
            留存月份
          </div>
          <el-date-picker
            class="ipt-sty"
            size="mini"
            v-model="page.belongAccountMonth"
            @change="onChangeBelongAccountMonth"
            type="month"
            align="center"
            range-separator="-"
            placeholder="请选择月份"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">人员姓名</div>
          <el-select
            v-model="page.staffGuidList"
            placeholder="请选择"
            class="ipt-sty"
            filterable
            size="mini"
            multiple
          >
            <el-option
              v-for="item in staffList"
              :key="item.guid"
              :label="item.staffName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <!-- <el-button
            size="mini"
            type="text"
            @click="onChangeShowMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button> -->
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box">
      <div class="button-area">
        <el-button size="mini" type="info" @click="exportData">
          导出数据
        </el-button>

        <el-button
          size="mini"
          type="info"
          @click="goToRetentionTaskConversionProgress"
        >
          导入数据
        </el-button>
      </div>
      <el-table :data="currentPageData" :height="tableHeight" stripe border>
        <el-table-column
          fixed="left"
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="staffName"
          label="人员姓名"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.staffName || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="mobileNo"
          label="人员手机号"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.mobileNo || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="留存公司"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.tenantName || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="belongAccountMonth"
          label="留存月份"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.belongAccountMonth | getMonth }}
          </template>
        </el-table-column>

        <el-table-column
          prop="money"
          label="留存金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.money || "-" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
      tableHeight: window.innerHeight - 275,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        belongAccountMonth: "", // 留存月份
        tenantGuid: "", //企业GUID
        staffGuidList: [], //人员姓名
      },
      tableData: [],
      tenantList: [], // 留存公司
      staffList: [], // 人员姓名
    };
  },
  methods: {
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    async exportData() {
      const f = this.checkSearch();
      if (!f) {
        return;
      }
      await this.getData();
      if (!this.tableData.length) {
        this.$message.error("没有可导出的数据");
        return;
      }
      const params = {
        ...this.page,
      };
      params.belongAccountMonth = params.belongAccountMonth.replace("-", "");
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task-change/left/export`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.reportJx(
        data.data.colNames,
        data.data.datas,
        data.data.sheetName,
        data.data.fileNam
      );
    },
    goToRetentionTaskConversionProgress() {
      this.$router.push({
        path: "/retentionTaskConversionProgress",
      });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
    },
    async getTenantOperationRelList() {
      const query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ["9901"],
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data.records || [];
    },
    async getStaff() {
      const query = {
        pageIndex: 1,
        pageSize: -1,
        bizState: "Y",
        tenantGuid: this.page.tenantGuid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msPersonnelService}/staff/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.data.msg);
        return;
      }
      this.staffList = data.data.records || [];
    },

    // 校验搜索条件必填
    checkSearch() {
      if (!this.page.tenantGuid) {
        this.$message.error("请选择留存公司");
        return;
      }
      if (!this.page.belongAccountMonth) {
        this.$message.error("请选择留存月份");
        return;
      }
      // 校验通过
      return true;
    },
    async getData() {
      const f = this.checkSearch();
      if (!f) {
        return;
      }
      const params = {
        ...this.page,
      };
      params.belongAccountMonth = params.belongAccountMonth.replace("-", "");
      this.fullscreenLoading = true;
      // 后端没分页 前端分页
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task-change/left/left-task-list`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
      }
      this.tableData = data.data;
    },
    async search() {
      this.page.pageIndex = 1;
      await this.getData();
    },
    emptySearch() {
      this.page = {
        ...this.page,
        pageIndex: 1,
        tenantGuid: "", //企业GUID
        staffGuidList: [], //人员姓名
        belongAccountMonth: "",
      };
      this.getData();
    },
    onChangeTenant(val) {
      this.page.tenantGuid = val;
      this.getStaff();
    },
    onChangeNewTenant(val) {
      this.page.changeTenantGuid = val;
    },
    onChangeBelongAccountMonth(val) {
      this.page.belongAccountMonth = val;
    },
  },
  async created() {
    await this.getTenantOperationRelList();
  },
  computed: {
    // 计算当前页数据
    currentPageData() {
      const start = (this.page.pageIndex - 1) * this.page.pageSize;
      const end = start + this.page.pageSize;
      return this.tableData.slice(start, end);
    },
    // 计算总条数
    total() {
      return this.tableData.length;
    },
  },
};
</script>

<style scoped lang="less">
.upload-demo {
  display: inline-block;
  margin: 0 5px;
}
</style>
